import { render, staticRenderFns } from "./PicturesReport.vue?vue&type=template&id=304a9c9e&scoped=true&"
import script from "./PicturesReport.vue?vue&type=script&lang=js&"
export * from "./PicturesReport.vue?vue&type=script&lang=js&"
import style0 from "./PicturesReport.vue?vue&type=style&index=0&id=304a9c9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304a9c9e",
  null
  
)

export default component.exports